/** Shared helpers for SuperAdmin SMS Packages module (SMS-only top-up packs). */

export function isSmsOnlyPackage(pkg) {
  if (!pkg) return false;
  const pType = (pkg.pType || pkg.PType || "").trim();
  if (pType.toUpperCase() === "SMS") return true;

  const ents = pkg.entitlements || pkg.Entitlements || [];
  if (!Array.isArray(ents) || ents.length === 0) return false;
  return ents.every((e) => {
    const type = (e.entitlementType || e.EntitlementType || "").trim();
    return type === "SmsSegments";
  });
}

export function getSmsQuantity(pkg) {
  const ents = pkg?.entitlements || pkg?.Entitlements || [];
  return (ents || [])
    .filter((e) => (e.entitlementType || e.EntitlementType) === "SmsSegments")
    .reduce((sum, e) => sum + (parseInt(e.quantity ?? e.Quantity, 10) || 0), 0);
}

export function getSellPrice(pkg) {
  const prices = pkg?.prices || pkg?.Prices || [];
  if (!prices.length) return 0;
  return parseFloat(prices[0].price ?? prices[0].Price ?? 0) || 0;
}

export function getActualPrice(pkg) {
  const prices = pkg?.prices || pkg?.Prices || [];
  if (!prices.length) return 0;
  const sell = getSellPrice(pkg);
  const actual = parseFloat(prices[0].actualPrice ?? prices[0].ActualPrice ?? 0) || 0;
  return actual > sell ? actual : sell;
}
